import { api } from '../api';

export type EstadoPago = 'pendiente' | 'aprobado' | 'rechazado' | 'cancelado';

export interface ResumenPagosMs2 {
  totalElegidoMs2: number;
  conPagoIniciado: number;
  porEstado: Record<EstadoPago, number>;
  montoCobrado: number;
  montoComprometido: number;
  aprobadosConDiscrepancia: number;
}

export interface LegajoPagoRow {
  legajoId: string;
  legajoNumero: string;
  empresaId: string;
  empresaNombre: string;
  titular: { nombres: string; apellido: string; documento: string; email?: string };
  monto: number;
  montoEsperado: number | null;
  montoDiscrepante: boolean;
  estado: EstadoPago | null;
  intentos: number;
  iniciadoAt?: string;
  actualizadoAt?: string;
  webId?: string;
}

export interface ListaPagosResp {
  total: number;
  rows: LegajoPagoRow[];
}

export async function getResumenPagosMs2(): Promise<ResumenPagosMs2> {
  const { data } = await api.get<ResumenPagosMs2>('/admin/pagos/resumen');
  return data;
}

export async function listarPagosMs2(opts: {
  estado?: EstadoPago;
  offset?: number;
  limit?: number;
}): Promise<ListaPagosResp> {
  const { data } = await api.get<ListaPagosResp>('/admin/pagos', { params: opts });
  return data;
}
